import Icon from '../components/Icon.vue'

Icon.register({"tumblr":{"width":1024,"height":1792,"paths":[{"d":"M944 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26t-142.5-74-95-106-55.5-120-16.5-118v-544h-168v-215q72-26 129-69.5t91-90 58-102 34-99 15-88.5q1-5 4.5-8.5t7.5-3.5h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tumblr.js
// module id = yr2V
// module chunks = 1